import {
  collection,
  doc,
  getDocs,
  getDoc,
  updateDoc,
  query,
  orderBy,
  serverTimestamp,
  Timestamp,
  limit,
} from "firebase/firestore";
import { db } from "@/lib/firebase";
import { COLLECTIONS } from "@/constants/firestoreCollections";

function normalizeDates(data: Record<string, unknown>): Record<string, unknown> {
  const result = { ...data };
  for (const key of ["createdAt", "updatedAt"]) {
    const val = result[key];
    if (val && typeof (val as { toDate?: () => Date }).toDate === "function") {
      result[key] = (val as Timestamp).toDate();
    }
  }
  return result;
}

export async function getAllQuoteRequests() {
  const q = query(
    collection(db, COLLECTIONS.QUOTE_REQUESTS),
    orderBy("createdAt", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({
    id: d.id,
    ...normalizeDates(d.data()),
  }));
}

export async function getQuoteRequestById(id: string) {
  const ref = doc(db, COLLECTIONS.QUOTE_REQUESTS, id);
  const snap = await getDoc(ref);
  if (!snap.exists()) return null;
  return { id: snap.id, ...normalizeDates(snap.data()) };
}

export async function updateQuoteRequestStatus(
  id: string,
  status: string,
  adminNotes?: string
) {
  const ref = doc(db, COLLECTIONS.QUOTE_REQUESTS, id);
  const updates: Record<string, unknown> = {
    status,
    updatedAt: serverTimestamp(),
  };
  if (adminNotes !== undefined) {
    updates.adminNotes = adminNotes;
  }
  await updateDoc(ref, updates);
}

export async function getRecentQuoteRequests(max = 5) {
  const q = query(
    collection(db, COLLECTIONS.QUOTE_REQUESTS),
    orderBy("createdAt", "desc"),
    limit(max)
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...normalizeDates(d.data()) }));
}

export async function linkQuoteToRequest(requestId: string, quoteId: string) {
  const ref = doc(db, COLLECTIONS.QUOTE_REQUESTS, requestId);
  await updateDoc(ref, {
    quoteId,
    status: "quoted",
    updatedAt: serverTimestamp(),
  });
}
